import { PrimaryPurpose, SourceOfFunds } from 'shared/data/walletsKyc/v1';

import { sortOtherLast } from '../../../../resources/helpers';
import { primaryPurposeMessages, sourceOfFundsMessages } from './StepForm.messages';

export const primaryPurposeToMessage = {
    [PrimaryPurpose.collecting_funds_from_clients]: primaryPurposeMessages.collectingFundsFromClients,
    [PrimaryPurpose.intercompany_transfers]: primaryPurposeMessages.interCompanyTransfers,
    [PrimaryPurpose.investment_activity]: primaryPurposeMessages.investmentActivity,
    [PrimaryPurpose.liquidity_fx]: primaryPurposeMessages.liquidityFx,
    [PrimaryPurpose.liquidity_or_fx]: primaryPurposeMessages.liquidityOrFx,
    [PrimaryPurpose.other]: primaryPurposeMessages.other,
    [PrimaryPurpose.paying_an_individual]: primaryPurposeMessages.payingAnIndividual,
    [PrimaryPurpose.paying_suppliers_or_bills]: primaryPurposeMessages.payingSuppliersOrBills,
    [PrimaryPurpose.payment_to_an_individual]: primaryPurposeMessages.paymentToAnIndividual,
    [PrimaryPurpose.property_purchase_or_sale]: primaryPurposeMessages.propertyPurchaseOrSale,
    [PrimaryPurpose.repatriating_overseas_earnings]: primaryPurposeMessages.repatriatingOverseasEarnings,
};

export const primaryPurposes = sortOtherLast(
    PrimaryPurpose,
    Object.keys(PrimaryPurpose).map((primaryPurpose: PrimaryPurpose) => ({
        id: primaryPurpose,
        name: primaryPurposeToMessage[primaryPurpose],
    }))
);

export const sourceOfFundsToMessage = {
    [SourceOfFunds.business_revenue]: sourceOfFundsMessages.businessRevenue,
    [SourceOfFunds.donations_or_grants]: sourceOfFundsMessages.donationsOrGrants,
    [SourceOfFunds.external_investment]: sourceOfFundsMessages.externalInvestment,
    [SourceOfFunds.inter_company_transfers]: sourceOfFundsMessages.interCompanyTransfers,
    [SourceOfFunds.loan]: sourceOfFundsMessages.loan,
    [SourceOfFunds.other]: sourceOfFundsMessages.other,
    [SourceOfFunds.sale_of_assets]: sourceOfFundsMessages.saleOfAssets,
};

export const sourcesOfFunds = sortOtherLast(
    SourceOfFunds,
    Object.keys(SourceOfFunds).map((sourceOfFunds: SourceOfFunds) => ({
        id: sourceOfFunds,
        name: sourceOfFundsToMessage[sourceOfFunds],
    }))
);
